import { createContext, useContext } from 'react'
import type { Toast } from '..'

type ContextTypes = {
  addToast: (el: Omit<Toast, 'uuid'>) => string
  addToastError: (message: string) => string
  addToastSuccess: (message: string) => string
  addToastInfo: (message: string) => string
  addToastProcess: (message: string) => string
  removeToast: (id: string) => void
  removeAllToasts: () => void
}

export const NotificationsContext = createContext<ContextTypes>({
  addToast: () => '',
  addToastError: () => '',
  addToastProcess: () => '',
  addToastInfo: () => '',
  addToastSuccess: () => '',
  removeToast: () => undefined,
  removeAllToasts: () => undefined,
})

export const useNotifications = () => {
  return useContext(NotificationsContext)
}
